import { capture } from "./capture";

export const LineageTracking = {
  /** Lineage export deleted. */
  exportDeleted: (itemId: string) => {
    capture("lineage.export_deleted", { item_id: itemId });
  },
};
